module.exports = __webpack_public_path__ + "static/media/digital-signage-img6.1fd84a5d.jpg";